var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.172L5.414 2.586a2 2 0 1 0-2.828 2.828L21.172 24 2.586 42.586a2 2 0 0 0 2.828 2.828L24 26.828l18.586 18.586a2 2 0 0 0 2.828-2.828L26.828 24 45.414 5.414a2 2 0 0 0-2.828-2.828L24 21.172z",
    fillRule: "nonzero",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError1);
export default __webpack_public_path__ + "static/media/error-1.4f5d2459a06835dfa64e647cebba7787.svg";
export { ForwardRef as ReactComponent };